import script from "./ModalEditarSeguimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditarSeguimiento.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditarSeguimiento.vue?vue&type=style&index=0&id=5191f44e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5191f44e"]])

export default __exports__